
import XDialog from 'vux/src/components/x-dialog/index.vue'

export default {
components: {
XDialog
},
data () {
return {
}
},
props: {
tips: String,   // 定义传值的类型
show: false
},
created: async function () {
},
methods: {
close () {

this.$emit('close')
}
}
}



// WEBPACK FOOTER //
// ./src/components/simple/appTipsDialog/App-tips-dialog.vue